import React, { useState } from 'react'
import {
  Box,
  Button,
  Heading,
  Stack,
  Text,
  VStack,
} from '@chakra-ui/react'
import { BasicReport, panasBasicOptions } from '../utils/types'
import { basicSelectQuestions } from '../utils/constants'
import QuestionCarouselNavigation from '../../../../components/QuestionCarouselNavigation'

interface PartBCarouselProps {
  values: BasicReport
  onChange: (name: keyof BasicReport, value: string) => void
}

const PartBCarousel: React.FC<PartBCarouselProps> = ({ values, onChange }) => {
  const [currentIndex, setCurrentIndex] = useState(0)

  const current = basicSelectQuestions[currentIndex]
  const currentValue = values[current.name]
  const total = basicSelectQuestions.length

  const handleSelect = (key: string) => {
    onChange(current.name, key)
    if (currentIndex < total - 1) {
      setCurrentIndex((i) => i + 1)
    }
  }

  const handlePrev = () => {
    setCurrentIndex((i) => Math.max(0, i - 1))
  }

  const handleNext = () => {
    setCurrentIndex((i) => Math.min(total - 1, i + 1))
  }

  return (
    <Stack spacing={4}>
      <Box
        borderRadius='lg'
        borderWidth='1px'
        borderColor='purple.100'
        bg='purple.50'
        p={6}
      >
        <VStack spacing={4} align='stretch'>
          <Text fontSize='lg' color='gray.500' textAlign='center'>
            {currentIndex + 1} of {total}
          </Text>
          <Heading fontSize='xl' overflowWrap='anywhere' textAlign='center' whiteSpace='normal'>
            {current.question}
          </Heading>
          <Stack spacing={2}>
            {(Object.entries(panasBasicOptions) as [keyof typeof panasBasicOptions, string][]).map(
              ([key, label]) => (
                <Button
                  key={key}
                  variant={currentValue === key ? 'solid' : 'outline'}
                  colorScheme='purple'
                  height='auto'
                  onClick={() => handleSelect(key)}
                  minH='3rem'
                  overflowWrap='anywhere'
                  size='lg'
                  whiteSpace='normal'
                >
                  {label}
                </Button>
              ),
            )}
          </Stack>
          <QuestionCarouselNavigation
            isNextDisabled={currentIndex === total - 1}
            isPreviousDisabled={currentIndex === 0}
            onNext={handleNext}
            onPrevious={handlePrev}
          />
        </VStack>
      </Box>
    </Stack>
  )
}

export default PartBCarousel
